let host = process.env.NODE_ENV != 'development'?'/api/':'http://localhost:8883/api/';
let pchost = process.env.NODE_ENV == 'production'?'https://talent.autohome.com.cn/':process.env.NODE_ENV == 'test'?'http://talent.yz.test.autohome.com.cn/':'';
//let host = '/'
module.exports = {
    logout: host + 'auto/logout',
    getLoginName: host + 'officialUser/getLoginName',
    initialData: host + 'officialUser/initialData',
    getUserInfo: host + 'officialUser/getUserInfo',
    saveResumeInfo: host + 'officialUser/saveResumeInfo',
    uploadResumeFile: host + 'officialUser/uploadResumeFile',
    getKnowList: host + 'officialUser/getKnowList',

    getPositionList: host + 'officialPosition/getPositionList',
    getSchoolRecruitPositionList: host + 'officialPosition/getSchoolRecruitPositionList',
    getPositionDetail: host + 'officialPosition/getPositionDetail',
    sendPositionUrl: host + 'officialPosition/sendPositionUrl',
    getSchoolRecruitHomePositionList: host + 'officialPosition/getSchoolRecruitHomePositionList',
    getSchoolRecruitOptions: host + 'officialPosition/getSchoolRecruitOptions',

    getDeliveryList: host + 'delivery/getDeliveryList',
    deliveryPosition: host + 'delivery/deliveryPosition',
    getResumeProcessList: host + 'delivery/getResumeProcessList',
    checkDelivery:host + 'delivery/checkDelivery',
    updateDelivery:host + 'delivery/updateDelivery',
    getDeliveryKnowSource:host + 'delivery/getDeliveryKnowSource',
    getDeliveryProcessList: host + 'delivery/getDeliveryProcessList',

    wxSignature: host + 'wx/getSignature',
    addAccessLog: host + 'access/addAccessLog',

    getMsg: host + 'officialUser/getMsg',

    getOnlineUri: host + 'officialUser/getOnlineUri',

    // 面试预约相关接口
    getInterviewInfo: host + 'interviewer/getInterviewInfo',
    saveInterviewTime: host + 'interviewer/saveInterviewTime',

    pchost:pchost,
}
